import { apiClient } from '@/services/ApiClient.js'

export class BlacklistService {
  query

  constructor(query) {
    this.query = query
  }

  getBlacklists() {
    return apiClient
      .get('blacklists', {
        params: this.query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getBlacklist(id) {
    return apiClient
      .get('blacklists/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  createBlacklist(blacklist) {
    return apiClient
      .post('blacklists', blacklist)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  updateBlacklist(id, blacklist) {
    return apiClient
      .patch('blacklists/' + id, blacklist)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  destroyBlacklist(id, removal_reason) {
    return apiClient
      .delete('blacklists/' + id + '?removal_reason=' + removal_reason)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
